import React, { useContext } from 'react';
import { bool, func, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import { StoreHeroContext } from '../../../StoreHero.context';
import styles from './feature-block.module.scss';

const cx = classNames.bind(styles);

const FeatureBlock = ({ feature, setStoreOverlayOpen }) => {
  const { channel } = useContext(ExperienceContext);
  const { store } = useContext(StoreHeroContext);
  const { storeDetailsPageLink } = store || {};

  const isStoreLayout = feature.title === 'Store Layout';
  const hrefPath = isStoreLayout ? null : `${storeDetailsPageLink}${feature.path}`;

  const imageClasses = cx('feature-block__image', {
    'feature-block__image--small': isStoreLayout
  });

  return (
    <a
      data-testid="feature-block-component"
      className={cx('feature-block')}
      href={hrefPath}
      onClick={isStoreLayout ? () => setStoreOverlayOpen(true) : () => { }}
    >
      <div className={cx('feature-block__wrapper')}>
        <h3 className={cx('feature-block__title')}>{feature?.title}</h3>
        <div className={cx('feature-block__link')}>{feature?.description}</div>
      </div>
      <Image
        alt=""
        asset={feature?.icon}
        className={imageClasses}
        height={40}
        width={60}
        title="Image Title"
      />
    </a>
  );
};

FeatureBlock.propTypes = {
  feature: shape({
    title: string.isRequired
  }).isRequired,
  setStoreOverlayOpen: func
};

FeatureBlock.defaultProps = {
  setStoreOverlayOpen: () => { }
};

FeatureBlock.displayName = 'StoreFeatureCard';

export { FeatureBlock };
